'use client';

import { useState } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { Button } from '@/components/ui/button';
import { SupportChatButton } from './support-chat-button';
import brand from '@/config/brand';
import {
	Sheet,
	SheetContent,
	SheetTrigger,
	SheetTitle,
} from '@/components/ui/sheet';

export function Header() {
	const [isMenuOpen, setIsMenuOpen] = useState(false);

	return (
		<header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
			<div className="container flex h-16 items-center justify-between">
				<Link href="/" className="flex items-center gap-2">
					<Image
						src={brand.logo.src}
						alt={brand.logo.alt}
						width={150}
						height={40}
						priority
					/>
				</Link>

				{/* Menu de desktop */}
				<nav className="hidden md:flex items-center gap-6">
					<Link
						href="/#pricing"
						className="text-sm text-muted-foreground hover:text-foreground"
					>
						Preços
					</Link>
					<Link
						href="/auth/login"
						className="text-sm text-muted-foreground hover:text-foreground"
					>
						Login
					</Link>
					<SupportChatButton />
					<Link
						href="/auth/register"
						className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 h-10 px-4 py-2 bg-black text-white hover:bg-gray-800"
					>
						Começar Grátis
					</Link>
				</nav>

				{/* Menu mobile */}
				<div className="flex items-center gap-2 md:hidden">
					<SupportChatButton />
					<Sheet open={isMenuOpen} onOpenChange={setIsMenuOpen}>
						<SheetTrigger asChild>
							<Button variant="outline" size="icon">
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
									stroke="currentColor"
									strokeWidth="2"
									strokeLinecap="round"
									strokeLinejoin="round"
									className="h-6 w-6"
								>
									<line x1="4" x2="20" y1="12" y2="12" />
									<line x1="4" x2="20" y1="6" y2="6" />
									<line x1="4" x2="20" y1="18" y2="18" />
								</svg>
							</Button>
						</SheetTrigger>
						<SheetContent side="right" className="w-[250px] p-6">
							<SheetTitle>Menu</SheetTitle>
							<div className="flex flex-col gap-6 mt-6">
								<Link
									href="/#pricing"
									className="text-lg font-medium text-foreground hover:text-muted-foreground"
									onClick={() => setIsMenuOpen(false)}
								>
									Preços
								</Link>
								<Link
									href="/auth/login"
									className="text-lg font-medium text-foreground hover:text-muted-foreground"
									onClick={() => setIsMenuOpen(false)}
								>
									Login
								</Link>
								<Link
									href="/auth/register"
									className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 h-10 px-4 py-2 bg-black text-white hover:bg-gray-800"
								>
									Começar Grátis
								</Link>
							</div>
						</SheetContent>
					</Sheet>
				</div>
			</div>
		</header>
	);
}
